<script>
  export default {
    methods: {
      getObjectByKeyValue (list, fieldName, code) {
        return list.find(obj => obj[fieldName] === code)
      }
    }
  }
</script>
